import React from 'react';
import { dropdown } from '../ui/uiTheme';

export default function ActionMenuItem({
  icon: Icon,
  label,
  onClick,
  active,
  variant = 'default',
  disabled = false,
}: any) {
  const colours = {
    default: disabled ? 'cursor-not-allowed text-slate-600' : dropdown.item,
    purple: disabled
      ? 'cursor-not-allowed text-slate-600'
      : active
        ? 'px-3 py-2 text-sm bg-brand-purple/10 text-brand-purple-light transition-colors duration-150 cursor-pointer flex w-full items-center gap-2.5'
        : 'px-3 py-2 text-sm text-slate-300 hover:bg-dark-base hover:text-brand-purple-light transition-colors duration-150 cursor-pointer flex w-full items-center gap-2.5',
    green: disabled
      ? 'cursor-not-allowed text-slate-600'
      : active
        ? 'px-3 py-2 text-sm bg-teal-900/20 text-teal-300 transition-colors duration-150 cursor-pointer flex w-full items-center gap-2.5'
        : 'px-3 py-2 text-sm text-slate-300 hover:bg-dark-base hover:text-teal-300 transition-colors duration-150 cursor-pointer flex w-full items-center gap-2.5',
    danger: disabled ? 'cursor-not-allowed text-slate-600' : dropdown.destructive,
  };
  return (
    <button
      type="button"
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`${colours[variant]} ${variant === 'default' && !disabled ? 'flex w-full items-center gap-2.5' : ''}`.trim()}
    >
      <Icon className="h-4 w-4 shrink-0" aria-hidden />
      {label}
    </button>
  );
}
